import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'
import { CustomAlertType } from 'builder/modules/jobSearch/types'
import { transformerCustomAlert } from './utils'

interface MutationParams {
  data: Partial<CustomAlertType>
  shouldUpdateCache?: boolean
}

export const useMutationCustomAlert = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (params: MutationParams): Promise<CustomAlertType> => {
      const res = await baseClient.put(`/job-alerts/v1/custom-subscriptions/${params.data.id}`, {
        active: params.data.active,
        location: params.data.location,
        target_role: params.data.targetRole,
        location_id: params.data.locationId,
        only_remote_jobs: params.data.onlyRemoteJobs,
        frequency: params.data.frequency,
      })
      return transformerCustomAlert(res.data)
    },
    {
      onSuccess: (data, variables) => {
        if (variables.shouldUpdateCache) {
          queryClient.setQueryData<CustomAlertType[]>(['useGetCustomAlerts'], customAlerts => {
            return (customAlerts || []).map(c => (c.id === data.id ? data : c))
          })
        }
      },
    },
  )
}
